import React, { useEffect, useState } from 'react'

import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage'
import { IconButton } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import * as S from './styles';
import WrapperModalSearchClaimComment from './modalSearchClaimComment/modalSearchClaimComment';
import { ClaimGridItemPartResponse } from '@/main/models/response';
import ColumnLabel from '../../common/columnLabel/columnLabel';
import TooltipComponent from '../tooltip/tooltipComponent';
import { getTranslateByKey, isEmpty } from '@/main/services/utils';

export interface IIconChatSearchClaimProps {
  quantity: number;
  guidQuoteItem: string;
  lastComment?: string;
  updateGridPartByGuidQuoteItem: (guidQuoteItem: string, objUpdate: Partial<ClaimGridItemPartResponse>) => void;
}
function IconChatSearchClaim(props: IIconChatSearchClaimProps) {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  function handleClickIconMessage(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    e.preventDefault();
    setIsOpenModal(true);
  };

  return (
    <S.Container>

      <TooltipComponent
        interactive
        placement='left'
        PopperProps={{
          disablePortal: false
        }}
        title={
          !isEmpty(props.lastComment) ? (

            <S.AreaToolltipLastComment>
              <span>{getTranslateByKey("information.lastComment")}</span>
              <span>{props.lastComment}</span>
            </S.AreaToolltipLastComment>
          ) : ""
        }
      >

        <IconButton
          onClick={handleClickIconMessage}
          id='id-searchClaim-btn-msg'
        >
          <MailOutlineIcon />
        </IconButton>
      </TooltipComponent>

      {props.quantity > 0 && <S.CountChat>{props.quantity}</S.CountChat>}

      <WrapperModalSearchClaimComment
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        closeModal={() => setIsOpenModal(false)}
        {...props}
      />
    </S.Container>
  )
}

export default IconChatSearchClaim